export default __webpack_public_path__ + "static/media/boostvoiceImg.f27e566c.png";